import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "456eab34-bb6c-467f-8302-51647f992a74", content: "High surface mass of the leaf", options: {} },
  { id: "8a27d1ca-ac09-4219-812b-929f253d419d", content: "High damping of the leaf", options: {} },
  { id: "bc51fd16-ce11-451a-98cc-008c79ae8a5b", content: "Laminated leaves", options: {} },
  { id: "7eb85290-a04c-445e-a108-51aa3cd8c306", content: "Low fundamental resonance", options: {} },
  { id: "9e9eaf4d-a967-41b7-bcd9-c3fc5616dea5", content: "Isotropic leaves", options: {} },
  { id: "c1528bdf-9011-4962-93a6-e228dd24e6eb", content: "Orthotropic leaves", options: {} },
  { id: "1001ebf6-c3dd-4896-a3b8-b68dc08af230", content: "Low coincidence frequency  ", options: {} },
  { id: "72176aed-c9b6-40d1-8834-ab2975404a7c", content: "High stiffness of the leaf", options: {} },
];

export const task: Task = {
  id: "bbeabb31-21a5-4bf7-ad85-a666b4d749ee",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "456eab34-bb6c-467f-8302-51647f992a74",
    "8a27d1ca-ac09-4219-812b-929f253d419d",
    "bc51fd16-ce11-451a-98cc-008c79ae8a5b",
    "7eb85290-a04c-445e-a108-51aa3cd8c306",
    "9e9eaf4d-a967-41b7-bcd9-c3fc5616dea5",
  ],
};
